import type { FC } from 'react';
import Link from 'next/link';
import { IconsNames } from '@eqi-investimentos/icons/web';
import { Flex } from '@eqi-investimentos/react';
import { Text } from '@chakra-ui/react';
import { Icon } from '@/components/atoms/Icon';
export const ServiceCard: FC<CrossSellWidgetCardProps> = ({
  path,
  icon,
  title
}) => {
  return <Flex as={Link} href={path} flexDir="row" w="14.75rem" maxW="14.75rem" h="6.75rem" p="m" gap="s" bg="background.brandLight" borderRadius="0.625rem" data-sentry-element="Flex" data-sentry-component="ServiceCard" data-sentry-source-file="Card.tsx">
      <Flex flexDir="column" justifyContent="space-between" alignItems="flex-start" gap="xs" w="12.5rem" h="full" cursor="pointer" data-sentry-element="Flex" data-sentry-source-file="Card.tsx">
        <Icon iconName={icon as IconsNames} w="1.5rem" h="1.5rem" color="content.brand" transition="all 300ms ease-in-out" data-sentry-element="Icon" data-sentry-source-file="Card.tsx" />
        <Text fontSize="md" lineHeight="6" textAlign="center" color="content.primary" whiteSpace="wrap" data-sentry-element="Text" data-sentry-source-file="Card.tsx">
          {title}
        </Text>
      </Flex>
    </Flex>;
};
type CrossSellWidgetCardProps = {
  path: string;
  icon: string;
  thumb?: string;
  title: string;
};